import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

import { getParamIfExists } from "@/utils";
import { apiCheckInternalQrcode } from "@/api";

import { LoadingOutlined } from "@ant-design/icons";

import { Card, Spin } from "antd";
import Footer from "@/components/internal/Footer";
import VerifyInfo from "@/components/internal/VerifyInfo";
import CommonSlider from "@/components/common/CommonSlider";
import ProductInfo from "@/components/internal/ProductInfo";
import ContactInfo from "@/components/internal/ContactInfo";
import DistributionInfo from "@/components/internal/DistributionInfo";

import { useScanQrcodeStore, useSettingStore } from "@/store";

import NoImage from "@/assets/images/no-image.png";

const BusinessView: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();

  const { isFetchInit } = useSettingStore();
  const { product, setDataScanQrcode } = useScanQrcodeStore();

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const initializeApp = async () => {
      if (!isFetchInit) {
        setTimeout(() => {
          if (isFetchInit) {
            initializeApp();
          }
        }, 500);
        return;
      }

      const searchParams = new URLSearchParams(location.search);
      const serialx = getParamIfExists(searchParams, "serial") || getParamIfExists(searchParams, "ser");

      try {
        if (serialx) {
          setIsLoading(true);
          const res = await apiCheckInternalQrcode(serialx);

          const dataResponse = res.data;
          const status: any = dataResponse?.stamp_code?.status || "";
          if (status === "not_found") {
            navigate("/not-found");
            setIsLoading(false);
            return;
          }

          setDataScanQrcode(dataResponse);
          setIsLoading(false);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 1000);
      }
      return;
    };

    initializeApp();
  }, []);

  if (isLoading) {
    return (
      <div className="qrx-container m-auto overflow-hidden">
        <div className="flex justify-center items-center min-h-screen">
          <div className="loading-overlay flex flex-col items-center justify-center gap-2">
            <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            <div className="loading-text">{t("common.loading")}</div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="m-auto min-h-screen">
      <Card className="qrx-card-bank mb-3">
        <CommonSlider images={[product?.image_url || NoImage]} />
        <div className="bg-[#4CB050] text-[16px] leading-5 p-4 text-white font-medium">
          {t("common.check_product_info")}
        </div>
      </Card>

      <DistributionInfo className="!my-2" />
      <VerifyInfo className="!my-2" />
      <ProductInfo className="!my-2" />
      <ContactInfo className="!my-2" />
      <Footer />
    </div>
  );
};

export default BusinessView;
